module.exports = __webpack_public_path__ + "static/img/5.f799106.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/4/eng/5.png
// module id = ghU8
// module chunks = 0